import { Component, input, output } from '@angular/core';
import { CommunicationUserType } from 'src/app/models/enums';
import { MessageChannel } from 'src/app/models/enums/messageChannel';
import { LiteralService, UtilsService } from 'src/app/services';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { IMessagesState } from 'src/app/store/states';
import { images } from 'src/images';

@Component({
  selector: 'app-messages-table',
  templateUrl: './messages-table.component.html',
  styleUrl: './messages-table.component.scss',
  standalone: false
})
export class MessagesTableComponent {
  readonly messages = input<IMessagesState>();
  readonly selectMessage = output<any>();
  readonly selectMessageDetail = output<any>();
  
  public images = images;
  public CommunicationUserType = CommunicationUserType;
  public TooltipPosition = TooltipPosition;
  public MessageChannel = MessageChannel;

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService
  ) { }

  showMessageData(id: number) {
    this.selectMessage.emit(id);
  }

  showMessageDetail(id: number) {
    this.selectMessageDetail.emit(id);
  }

}
